import { connect } from "react-redux";
import { QRCodeLidnummer } from '../presentational/QRCodeLidnummer';

export interface QRCodeProps {
    lidnummer: any;
}

const mapStateToProps = (state : any) => {
    return {
        lidnummer: state.user.lidnummer
    };
  };

export const QRCodeContainer = connect(mapStateToProps)(QRCodeLidnummer);
